import React from 'react';
import { Box, Container, Stack, Typography } from '@mui/material';
import { VaqtlyMark, VAQTLY_INK } from '../ProductLogos';
import { PALETTE } from '../../theme';
import { products } from '../../data/products';
import { useT } from '../../lib/i18n';

/** TODO(vaqtly): placeholder contact address — replace with the real inbox. */
export const CONTACT_EMAIL = 'hello@vaqtly.uz';

export default function SiteFooter() {
  const t = useT();

  return (
    <Box component="footer" sx={{ borderTop: `2px solid ${PALETTE.hairline}`, mt: { xs: 10, md: 14 } }}>
      <Container maxWidth="lg" sx={{ py: { xs: 6, md: 8 } }}>
        <Stack direction={{ xs: 'column', md: 'row' }} spacing={{ xs: 5, md: 4 }} justifyContent="space-between">
          <Box sx={{ maxWidth: 320 }}>
            <Stack direction="row" alignItems="center" spacing={1.25}>
              <VaqtlyMark size={32} />
              <Box component="span" sx={{ fontSize: 21, fontWeight: 800, color: VAQTLY_INK, letterSpacing: '-0.02em' }}>
                vaqtly
              </Box>
            </Stack>
            <Typography sx={{ mt: 1.5, fontSize: 15, color: PALETTE.inkMuted }}>{t.footer.tagline}</Typography>
          </Box>

          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 4, sm: 8 }}>
            <Box>
              <FooterHeading>{t.footer.products}</FooterHeading>
              <Stack spacing={1}>
                {products.map((product) =>
                  product.url ? (
                    <FooterLink key={product.id} href={product.url} external>
                      {product.name}
                    </FooterLink>
                  ) : (
                    <Box key={product.id} sx={{ fontSize: 15, fontWeight: 700, color: PALETTE.inkFaint }}>
                      {product.name}
                    </Box>
                  ),
                )}
              </Stack>
            </Box>

            <Box>
              <FooterHeading>{t.footer.contact}</FooterHeading>
              <Stack spacing={1}>
                <FooterLink href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</FooterLink>
                <FooterLink href="#about">{t.footer.about}</FooterLink>
              </Stack>
            </Box>
          </Stack>
        </Stack>

        <Typography sx={{ mt: { xs: 6, md: 8 }, fontSize: 14, color: PALETTE.inkFaint }}>
          © {new Date().getFullYear()} Vaqtly Holding. {t.footer.rights}
        </Typography>
      </Container>
    </Box>
  );
}

function FooterHeading({ children }: { children: React.ReactNode }) {
  return (
    <Typography
      sx={{
        mb: 1.5,
        fontSize: 12,
        fontWeight: 800,
        letterSpacing: '0.12em',
        textTransform: 'uppercase',
        color: PALETTE.inkFaint,
      }}
    >
      {children}
    </Typography>
  );
}

function FooterLink({
  href,
  external = false,
  children,
}: {
  href: string;
  external?: boolean;
  children: React.ReactNode;
}) {
  return (
    <Box
      component="a"
      href={href}
      {...(external ? { target: '_blank', rel: 'noopener noreferrer' } : null)}
      sx={{
        fontSize: 15,
        fontWeight: 700,
        color: PALETTE.inkMuted,
        textDecoration: 'none',
        transition: 'color 150ms ease',
        '&:hover': { color: PALETTE.signal },
      }}
    >
      {children}
    </Box>
  );
}
